<div class="row m-3">
    @for (sample of sampleList; track sample.id) {
        <div class="col-md-4 col-lg-3 mt-3">
            <span class="label">Code d'Échantillon :</span>
            <p>{{ sample.sampleCode }}</p>
        </div>
        <div class="col-md-4 col-lg-3 mt-3">
            <span class="label">Référence de rapport :</span>
            <p>{{ sample.reportNumber }}</p>
        </div>


        <div class="col-md-4 col-lg-3 mt-3">
            <span class="label">Status :</span>
            <p>{{ sample.status }}</p>
        </div>

        <div class="col-md-4 col-lg-3 mt-3">
            <span class="label">Date de création :</span>
            <p>{{ sample.creationDate |date:'dd/MM/yyyy'}}</p>
        </div>

        <div class="col-md-4 col-lg-3 mt-3">
            <span class="label">Mise à jour :</span>
            <p>{{ sample.updateDate | date:'dd/MM/yyyy'}}</p>
        </div>

        <hr class="mt-3" *ngIf="!$last"/>
    } @empty {
        <div class="no-client-details mx-3 mt-3 w-5">
            <p>Aucun rapport n'est disponible pour ce client.</p>
        </div>
    }
</div>

